import {
	AddMeasurementTagToChecklistStepRequest,
	CreateChecklistRequest,
	CreateChecklistResponse,
	CreateChecklistStepRequest,
	DeleteChecklistStepRequest,
	DeleteMeasurementTagFromChecklistStepRequest,
	UpdateChecklistStepRequest,
} from "@/components/Procedures/Types/ManualChecklistTypes";

import { DataAdapter } from "@/DataAdapter/DataAdapter";

export const CreateChecklist = async (request: CreateChecklistRequest) => {
	return DataAdapter.Post<CreateChecklistResponse>(`checklist`, request);
};

export const AddSATOSLiveTagToChecklistStep = async (
	request: AddMeasurementTagToChecklistStepRequest,
) => {
	return DataAdapter.Post(`checklistSteps/MeasurementTag`, request);
};

export const CreateChecklistStep = async (
	request: CreateChecklistStepRequest,
) => {
	return DataAdapter.Post(`checklistSteps`, request);
};

export const UpdateChecklistStep = async (
	request: UpdateChecklistStepRequest,
) => {
	return DataAdapter.Patch(`checklistSteps/${request.StepId}`, request);
};

export const DeleteChecklistStep = async (
	request: DeleteChecklistStepRequest,
) => {
	return DataAdapter.Delete(`checklistSteps/${request.StepId}`, request);
};

export const DeleteSATOSLiveTagFromChecklistStep = async (
	request: DeleteMeasurementTagFromChecklistStepRequest,
) => {
	return DataAdapter.Delete(
		`checklistSteps/${request.StepId}/MeasurementTag`,
		request,
	);
}
